import { zod, type FormData } from "@subly/s1/features/form/models";

export type WelcomeActions = "back" | "next";

// BRANDING
export const BrandingSchema = zod.object({
	logo: zod.object({
		light: zod.union([zod.string(), zod.file()]),
		dark: zod.union([zod.string(), zod.file()]),
		mark: zod.union([zod.string(), zod.file()])
	}),
	url: zod.string()
});
export type BrandingType = FormData<typeof BrandingSchema>;

// CMS
export const CMSSchema = zod.object({
	cms: zod.string(),
	paywall: zod.string()
});
export type CMSType = FormData<typeof CMSSchema>;

// PRICING
export const PricingSchema = zod.object({
	articlePrice: zod.string().min(1, "Article price is required"),
	pass: zod.object({
		enabled: zod.boolean(),
		price: zod.string(),
		duration: zod.string()
	})
}).superRefine((data, ctx) => {
	if (data.pass.enabled) {
		if (Number(data.pass.price) < 1) {
			ctx.addIssue({ code: "custom", path: ["pass", "price"], message: "Price is required" });
		}
		if (Number(data.pass.duration) < 1) {
			ctx.addIssue({ code: "custom", path: ["pass", "duration"], message: "Duration must be greater than 0" });
		}
	}
});
export type PricingType = FormData<typeof PricingSchema>;